var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card" },
    [
      _c("div", { staticClass: "card__title" }, [
        _c("h5"),
        _vm._v(" "),
        _c("div", { staticClass: "card__controls" }, [
          _c(
            "div",
            { staticClass: "form-field" },
            [
              _c("input-field", {
                attrs: {
                  id: "busqueda_ventas" + _vm.tipoVenta,
                  placeholder: "Realice una búsqueda..."
                },
                model: {
                  value: _vm.searchVentas,
                  callback: function($$v) {
                    _vm.searchVentas = $$v
                  },
                  expression: "searchVentas"
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card__content" }, [
        _c(
          "div",
          { staticClass: "table-responsive" },
          [
            _c("table", { staticClass: "custom-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Venta")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Cliente")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Fecha")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Valor total")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Comisión")]),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.tipoVenta === "I" || _vm.tipoVenta === "R",
                          expression: "tipoVenta === 'I' || tipoVenta === 'R'"
                        }
                      ]
                    },
                    [_vm._v("Pago")]
                  ),
                  _vm._v(" "),
                  _c("th", [
                    _c(
                      "button",
                      {
                        staticClass: "btn-success",
                        attrs: { tooltip: "Agregar venta" },
                        on: { click: _vm.agregarVentas }
                      },
                      [_c("i", { staticClass: "fa fa-plus" })]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.ventas, function(venta, index) {
                    return _c(
                      "tr",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.coincideVentas(venta),
                            expression: "coincideVentas(venta)"
                          }
                        ],
                        key: venta.id
                      },
                      [
                        _c("td", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(venta.numero_documento) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(venta.nombre_cliente) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(venta.fecha) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.moneyFormat(venta.valor_total)) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.moneyFormat(venta.valor_comision)) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.tipoVenta === "I" ||
                                  _vm.tipoVenta === "R",
                                expression:
                                  "tipoVenta === 'I' || tipoVenta === 'R'"
                              }
                            ]
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.moneyFormat(venta.valor_pago)) +
                                "\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn-danger btn--text",
                              attrs: { tooltip: "Quitar" },
                              on: {
                                click: function($event) {
                                  return _vm.quitarVenta(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.ventas.length === 0,
                          expression: "ventas.length === 0"
                        }
                      ]
                    },
                    [
                      _c(
                        "td",
                        {
                          attrs: {
                            colspan:
                              _vm.tipoVenta === "I" || _vm.tipoVenta === "R"
                                ? 7
                                : 6
                          }
                        },
                        [_c("strong", [_vm._v("No se ha agregado ventas.")])]
                      )
                    ]
                  )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c(
              "modal",
              {
                attrs: {
                  clickToClose: false,
                  name: "tableSelectVen" + _vm.tipoVenta,
                  height: "auto",
                  width: "70%",
                  scrollable: "",
                  resizable: "",
                  adaptive: "",
                  reset: ""
                }
              },
              [
                _c("k-table-select", {
                  ref: "kTableSelectVen",
                  attrs: {
                    columnaSaldo:
                      _vm.tipoVenta === "I"
                        ? "saldo_incobrable"
                        : "saldo_retorno",
                    saldoSeleccionable:
                      _vm.tipoVenta === "I" || _vm.tipoVenta === "R",
                    columnas: [
                      {
                        nombre: "numero_documento",
                        descripcion: "Número de documento",
                        link: true
                      },
                      {
                        nombre: "cliente.descripcion_cliente",
                        descripcion: "Cliente"
                      },
                      {
                        nombre: "fecha",
                        descripcion: "Fecha",
                        sortable: true
                      },
                      {
                        nombre: "venta_total",
                        descripcion: "Venta total",
                        sortable: true,
                        money: true
                      },
                      {
                        nombre: "valor_total",
                        descripcion: "Valor total",
                        sortable: true
                      },
                      {
                        nombre: "total_pagado",
                        descripcion: "Abonado",
                        money: true,
                        sortable: true
                      },
                      {
                        nombre: "valor_comision",
                        descripcion: "Comisión",
                        money: true,
                        sortable: true
                      },
                      {
                        nombre: "saldo_incobrable",
                        descripcion: "Saldo incobrable",
                        money: true,
                        sortable: true,
                        hidden: _vm.tipoVenta !== "I"
                      },
                      {
                        nombre: "saldo_retorno",
                        descripcion: "Saldo retorno",
                        money: true,
                        sortable: true,
                        hidden: _vm.tipoVenta !== "R"
                      },
                      {
                        nombre: "valor_pago",
                        descripcion: "Valor seleccionado",
                        money: true,
                        sortable: true,
                        hidden: _vm.tipoVenta !== "I" && _vm.tipoVenta !== "R"
                      },
                      {
                        nombre: "valor_devoluciones",
                        descripcion: "Devoluciones",
                        money: true,
                        sortable: true
                      },
                      {
                        nombre: "valor_notas_credito",
                        descripcion: "Notas de crédito",
                        money: true,
                        sortable: true
                      }
                    ],
                    params: {
                      supervisor_id: _vm.supervisor_id,
                      tipoVenta: _vm.tipoVenta,
                      liquidacion_id: _vm.liquidacion_id
                    },
                    urlConsulta: _vm.url + "/ventas-nomina-supervisor",
                    title: "Seleccione una o varias ventas"
                  },
                  on: {
                    visitarLink: _vm.visitarLink,
                    cerrar: _vm.cerrarVentas,
                    seleccionar: _vm.seleccionarVentas
                  },
                  model: {
                    value: _vm.ventas,
                    callback: function($$v) {
                      _vm.ventas = $$v
                    },
                    expression: "ventas"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: { name: "mover" + _vm.tipoVenta, height: "auto", width: "60%" }
        },
        [
          _c("div", { staticClass: "layout" }, [
            _c("div", { staticClass: "layout__header" }, [
              _c("div", { staticClass: "layout__title" }, [
                _c("h5", [_vm._v("Mover")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12" }, [
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoVenta !== "C",
                        expression: "tipoVenta !== 'C'"
                      }
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "canceladas_opt" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.moverA,
                            expression: "moverA"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "mover_a",
                          id: "canceladas_opt",
                          value: "C"
                        },
                        domProps: { checked: _vm._q(_vm.moverA, "C") },
                        on: {
                          change: function($event) {
                            _vm.moverA = "C"
                          }
                        }
                      }),
                      _c("span", [_vm._v("Canceladas")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoVenta !== "DC",
                        expression: "tipoVenta !== 'DC'"
                      }
                    ]
                  },
                  [
                    _c(
                      "label",
                      { attrs: { for: "devoluciones_completas_opt" } },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.moverA,
                              expression: "moverA"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "mover_a",
                            id: "devoluciones_completas_opt",
                            value: "DC"
                          },
                          domProps: { checked: _vm._q(_vm.moverA, "DC") },
                          on: {
                            change: function($event) {
                              _vm.moverA = "DC"
                            }
                          }
                        }),
                        _c("span", [_vm._v("Devoluciones completas")])
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoVenta !== "DP",
                        expression: "tipoVenta !== 'DP'"
                      }
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "parciales_opt" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.moverA,
                            expression: "moverA"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "mover_a",
                          id: "parciales_opt",
                          value: "DP"
                        },
                        domProps: { checked: _vm._q(_vm.moverA, "DP") },
                        on: {
                          change: function($event) {
                            _vm.moverA = "DP"
                          }
                        }
                      }),
                      _c("span", [_vm._v("Devoluciones parciales")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoVenta !== "R",
                        expression: "tipoVenta !== 'R'"
                      }
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "retornos_opt" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.moverA,
                            expression: "moverA"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "mover_a",
                          id: "retornos_opt",
                          value: "R"
                        },
                        domProps: { checked: _vm._q(_vm.moverA, "R") },
                        on: {
                          change: function($event) {
                            _vm.moverA = "R"
                          }
                        }
                      }),
                      _c("span", [_vm._v("Retornos")])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.tipoVenta !== "I",
                        expression: "tipoVenta !== 'I'"
                      }
                    ]
                  },
                  [
                    _c("label", { attrs: { for: "incobrables_opt" } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.moverA,
                            expression: "moverA"
                          }
                        ],
                        attrs: {
                          type: "radio",
                          name: "incobrables",
                          id: "incobrables_opt",
                          value: "I"
                        },
                        domProps: { checked: _vm._q(_vm.moverA, "I") },
                        on: {
                          change: function($event) {
                            _vm.moverA = "I"
                          }
                        }
                      }),
                      _c("span", [_vm._v("Incobrables")])
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "btn-success",
                  attrs: { type: "button" },
                  on: { click: _vm.confirmar }
                },
                [
                  _c("i", { staticClass: "fa fa-check" }),
                  _c("span", [_vm._v("Confirmar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-danger btn--text",
                  attrs: { type: "button" },
                  on: { click: _vm.cerrar }
                },
                [
                  _c("i", { staticClass: "fa fa-times" }),
                  _c("span", [_vm._v("Cerrar")])
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1af0fe2d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af0fe2d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/VentasLiquidacion.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-1af0fe2d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/pedidos/VentasLiquidacion.vue
// module chunks = 0